import React, { useState } from "react";
import Link from "next/link";
import moment from "moment";
import News_item from "../../components/blog/news_item";
import { news_data, single_news_data } from "../../data/news_data";
import Meta from "../../components/Meta";
import { getAllPostsForHome } from "../../lib/api";

const Blog = ({ preview, allPosts }) => {
  const [loadMoreBtn, setLoadMoreBtn] = useState(allPosts.length > 4);
  const [data, setdata] = useState(allPosts.slice(1, 4));

  const featuredArticle = allPosts[0];

  const handleLoadMore = () => {
    setdata(allPosts.slice(1));
    setLoadMoreBtn(false);
  };

  return (
    <>
      <Meta title="Blog" />
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 block dark:hidden h-full">
        <img
          src="/images/gradient.jpg"
          alt="gradient"
          className="h-full w-full"
        />
      </picture>
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 hidden dark:block">
        <img
          src="/images/gradient_dark.jpg"
          alt="gradient dark"
          className="h-full w-full"
        />
      </picture>
      {/* <!-- Blog --> */}
      <section className="relative  pt-[5.5rem] lg:pt-24">
        <div className="py-10">
          <div className="container">
            {/* <!-- Featured Post --> */}
            <article className="mb-[1.875rem] md:mb-16">
              <div className="rounded-2xl flex flex-col overflow-hidden transition-shadow hover:shadow-lg md:flex-row">
                <figure className="group overflow-hidden md:w-1/2">
                  <Link href={`/blog/${featuredArticle?.slug}`}>
                    <img
                      src={featuredArticle?.coverImage.url}
                      alt={featuredArticle?.coverImage.description}
                      className="h-full w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                    />
                  </Link>
                </figure>

                {/* <!-- Body --> */}
                <div className="dark:border-jacarta-600 dark:bg-jacarta-700 border-jacarta-100 rounded-b-[1.25rem] border bg-white p-[10%] md:w-1/2 md:rounded-none md:rounded-r-[1.25rem]">
                  {/* <!-- Meta --> */}
                  <div className="mb-3 flex flex-wrap items-center space-x-1 text-xs">
                    <Link
                      href="#"
                      className="dark:text-jacarta-200 text-jacarta-700 font-display hover:text-accent"
                    >
                      {featuredArticle?.author.name}
                    </Link>
                    <span className="dark:text-jacarta-400 font-display">
                      in
                    </span>
                    <span className="text-accent inline-flex flex-wrap items-center space-x-1 font-display uppercase">
                      <a href="#">{featuredArticle?.topic}</a>
                    </span>
                  </div>

                  <h2 className="font-display text-jacarta-700 dark:hover:text-accent hover:text-accent mb-4 text-xl dark:text-white sm:text-3xl">
                    <Link href={`/blog/${featuredArticle?.slug}`}>
                      {featuredArticle?.title}
                    </Link>
                  </h2>
                  <p className="dark:text-jacarta-200 mb-8">
                    {featuredArticle?.excerpt}
                  </p>

                  {/* <!-- Date / Time --> */}
                  <div className="text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm">
                    <span>
                      <time>
                        {moment(featuredArticle?.datePublished).format(
                          "MMM D, YYYY  hh:mm A"
                        )}
                      </time>
                    </span>
                    <span>•</span>
                    <span>{featuredArticle?.timeToRead} minute read</span>
                  </div>
                </div>
              </div>
            </article>

            <News_item data={data} />

            {/* <!-- Load More --> */}
            {loadMoreBtn && (
              <div className="mt-10 text-center">
                <button
                  onClick={handleLoadMore}
                  className="bg-accent shadow-accent-volume hover:bg-accent-dark inline-block rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
                >
                  Load More
                </button>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* <!-- end blog --> */}
    </>
  );
};

export default Blog;

export async function getStaticProps({ preview = false }) {
  const allPosts = (await getAllPostsForHome(preview)) ?? [];
  return {
    props: { preview, allPosts },
    revalidate: 10,
  };
}
